<div>
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Special Requirements</mat-label>
    <textarea matInput rows="3" [(ngModel)]="pluginData.specialRequirements"
      placeholder="Any special requirements or instructions"></textarea>
  </mat-form-field>
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Final Comments</mat-label>
    <textarea matInput rows="3" [(ngModel)]="pluginData.finalComments"
      placeholder="Additional comments"></textarea>
  </mat-form-field>
</div>
